import { userIsAtLeast } from 'lib/user'
import { PLANS } from '../../../server/lib/constants'
import { MODAL_FROM_CONTEXTS } from '../../store/ui/actions'
import Button from '../forms/Button'
import styles from './styles/Citations.css'

const ExportReport = ({ doi, user, toggleModal }) => {
  const handleClick = () => {
    // if a user is an expert or does not have a free plan allow export.
    if (user && (user.expert || userIsAtLeast(user, PLANS.premium))) {
      toggleModal('exportReport')
      return
    }
    toggleModal(user ? 'upgrade' : 'login', true, MODAL_FROM_CONTEXTS.REPORT_DOWNLOAD)
  }

  return (
    <Button className={styles.reportExport} onClick={handleClick}>
      <img
        alt='Export report'
        src={`${CONFIG.assetsBaseURL}/images/icons/reports/download-csv.svg`}
        width='16px'
        height='16px'
      />
      <span className={styles.reportExportText}>Export report</span>
    </Button>
  )
}

export default ExportReport
